import { mapGetters } from 'vuex'
import { FUNNELS } from '@/data/funnels'
import { FUNNEL_SOURCES } from '@/helpers/constants'
import { ENV_DEV_OR_STAGING } from '@/helpers/environment'

export default {
	computed: {
		...mapGetters({
			FEAT_FUNNEL_SOURCES: 'coreFeatures/FEAT_FUNNEL_SOURCES',
			isPaidTraffic: 'location/isPaidTraffic',
			funnelType: 'location/getFunnelType',
			language: 'i18n/getLanguage'
		}),
		MAIN_FUNNEL_ROUTE_NAME() {
			const mainFunnelAccessFeatureFlagByEnv = ENV_DEV_OR_STAGING
				? this.FEAT_FUNNEL_SOURCES.mainStage
				: this.FEAT_FUNNEL_SOURCES.main
			if (mainFunnelAccessFeatureFlagByEnv === FUNNEL_SOURCES.LEGACY) {
				if (this.isPaidTraffic) {
					return 'weight-loss-goals'
				} else {
					return 'intermittent-fasting'
				}
			}

			return 'new-survey'
		},
		NOFASTING_FUNNEL_ROUTE_NAME() {
			if (this.FEAT_FUNNEL_SOURCES.nofasting === FUNNEL_SOURCES.LEGACY) {
				return 'survey'
			}
			return this.IS_FEMALE_FUNNEL ? 'female-survey' : 'new-survey'
		},
		IS_MAIN_FUNNEL() {
			return [FUNNELS.MAIN.id, FUNNELS.MAIN_NON_US.id, FUNNELS.LEGACY.id].includes(this.funnelType.id)
		},
		IS_EMAIL_BEFORE_PREDICT_FUNNEL() {
			return [FUNNELS.MAIN.id, FUNNELS.MALE_EMAIL_BEFORE_PREDICT.id, FUNNELS.FEMALE_EMAIL_BEFORE_PREDICT.id].includes(
				this.funnelType.id
			)
		},
		IS_MALE_FUNNEL() {
			return [
				FUNNELS.MALE.id,
				FUNNELS.MALE_EMAIL_BEFORE_PREDICT.id,
				FUNNELS.NOFASTING_MALE.id,
				FUNNELS.MALE_ACTIVITY_FUNNEL.id,
				FUNNELS.NOFASTING_ACTIVITY_MALE.id
			].includes(this.funnelType.id)
		},
		IS_FEMALE_FUNNEL() {
			return [
				FUNNELS.FEMALE.id,
				FUNNELS.FEMALE_EMAIL_BEFORE_PREDICT.id,
				FUNNELS.NOFASTING_FEMALE.id,
				FUNNELS.FEMALE_OPTIMIZED.id,
				FUNNELS.FEMALE_ACTIVITY_FUNNEL.id
			].includes(this.funnelType.id)
		},
		IS_MALE_ACTIVITY_FUNNEL() {
			return [FUNNELS.MALE_ACTIVITY_FUNNEL.id].includes(this.funnelType.id)
		},
		IS_FEMALE_ACTIVITY_FUNNEL() {
			return [FUNNELS.FEMALE_ACTIVITY_FUNNEL.id].includes(this.funnelType.id)
		},
		IS_YOUTUBE_FUNNEL() {
			return [FUNNELS.YOUTUBE.id].includes(this.funnelType.id)
		},
		IS_NOFASTING_FUNNEL() {
			return [FUNNELS.NOFASTING.id].includes(this.funnelType.id)
		},
		IS_NOFASTING_ACTIVITY_MALE() {
			return [FUNNELS.NOFASTING_ACTIVITY_MALE.id].includes(this.funnelType.id)
		},
		getFunnelTypeStringForGTM() {
			if (this.IS_FEMALE_FUNNEL) {
				return 'female'
			}
			if (this.IS_MALE_FUNNEL) {
				return 'male'
			}
			return 'other'
		}
	}
}
